<template>
  <div class="xrow">
    <div class="col-1-2">
      <div class="form-group">
        <label for="">Descrição:</label>
        <input class="form-control" maxlength="250" v-model="item.descricao"/>
        <div class="message">{{ validation.firstError("item.descricao") }}</div>
      </div>
    </div>
    <div class="col-1-4">
      <div class="form-group">
        <label for="">Data de início:</label>
        <div style="display: flex; align-items: center;">
          <datetime
            inputId="dtIni"
            input-class="form-control"
            type="date"
            v-model="item.data_inicial"
            :max-datetime="item.data_final || null"
            :phrases="{ok: 'Confirmar', cancel: 'Fechar'}"
            value-zone="local"
            format="d/M/y"
          />
          <button 
            type="button" 
            class="btn btn-sm btn-outline-secondary ml-1" 
            @click="limparDataInicial"
            title="Limpar data"
            style="height: 38px;"
          >
            <fa-icon icon="trash-alt" />
          </button>
        </div>
        <div class="message">{{ getMessageDataInicial() }}</div>
      </div>
    </div>
    <div class="col-1-4">
      <div class="form-group">
        <label for="">Data de término:</label>
        <div style="display: flex; align-items: center;">
          <datetime
            inputId="dtFim"
            input-class="form-control"
            type="date"
            :min-datetime="item.data_inicial || null"
            v-model="item.data_final"
            :phrases="{ok: 'Confirmar', cancel: 'Fechar'}"
            value-zone="local"
            format="d/M/y"
          />
          <button 
            type="button" 
            class="btn btn-sm btn-outline-secondary ml-1" 
            @click="limparDataFinal"
            title="Limpar data"
            style="height: 38px;"
          >
            <fa-icon icon="trash-alt" />
          </button>
        </div>
        <div class="message">{{ getMessageDataFinal() }}</div>
      </div>
    </div>
    <div class="col-1-4">
      <div class="form-group">
        <label for="">Ativo:</label>
        <select class="form-control" v-model="ativoModel">
          <option :value="true">Sim</option>
          <option :value="false">Não</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'informacao',
  props: ['item', 'validation'],
  computed: {
    ativoModel: {
      get() {
        return Boolean(this.item.ativo);
      },
      set(value) {
        this.item.ativo = value;
      }
    },
  },
  methods: {
    limparDataInicial() {
      this.item.data_inicial = null;
    },
    limparDataFinal() {
      this.item.data_final = null;
    },
    getMessageDataInicial() {
      return this.item.data_inicial === null ? "A regra terá início imediato." : null;
    },
    getMessageDataFinal() {
      return this.item.data_final === null ? "A regra não terá prazo de término." : null;
    }
  },
  mounted() {
    if(!this.item.data_inicial) {
      this.item.data_inicial = null;
    }
    if(!this.item.data_final) {
      this.item.data_final = null;
    }
  },
};
</script>
